import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { CommandProgressEffects } from './command-progress.effects';
import { commandProgressFeatureKey, commandProgressReducer } from './command-progress.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(commandProgressFeatureKey, commandProgressReducer),
    EffectsModule.forFeature([CommandProgressEffects]),
  ],
  providers: [],
})
export class CommandProgressStoreModule {}
